import { reactive } from 'vue'

// 全局设备状态
const deviceState = reactive({
  isMobile: false
})

// 检测是否为移动端（竖屏即为移动端）
function checkMobile() {
  const width = window.innerWidth
  const height = window.innerHeight
  
  // 只要是竖屏（高度 > 宽度）就按手机端处理
  deviceState.isMobile = height > width
}

// 初始化：立即检测一次，并监听窗口变化
function initDeviceDetection() {
  checkMobile()
  window.addEventListener('resize', checkMobile)
}

// 销毁监听（一般不需要调用，因为是全局的）
function destroyDeviceDetection() {
  window.removeEventListener('resize', checkMobile)
}

// 立即初始化
initDeviceDetection()

export {
  deviceState,
  checkMobile,
  initDeviceDetection,
  destroyDeviceDetection
}






